import { ButtonGroup } from "@vds/buttons";
import { Icon } from "@vds/icons";
import { Line } from "@vds/lines";
import { Modal, ModalBody } from "@vds/modals";
import { Notification } from "@vds/notifications";
import { DropdownSelect } from "@vds/selects";
import { Body } from "@vds/typography";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import {
  CompanionGrayContainer,
  FloorText,
} from "../../global/components/OnboardingFormStyles/Styles";
import { BasicSnapshot } from "../../global/components/snapshots/BasicSnapshot";
import {
  CCD_MODEL_MEDIUM,
  CCD_MODEL_MEDIUM_LIMIT,
  CCD_MODEL_SMALL,
  CCD_MODEL_SMALL_LIMIT,
} from "../../global/constants/devices";
import { snapshotImage, StreamType } from "../../hoc/snapshotImage";
import { getFovNames, setFloorSelected, setSelecedCompanion } from "../../store/actions";
import SelectFloorPlan from "./SelectFloorPlan";
import { CAMERA_ONBOARDING_TEST_IDS } from "./cameraOnboardingConstants";

const BIContent = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: start;
  gap: 4px;
  width: 100%;
`;
const BoldText = styled.div`
  color: #6f7171;
  font-feature-settings: "clig" off, "liga" off;
  /* [VDS] DeskTab/🖥 Body LG Bold */
  font-family: "Verizon-NHG-eDS";
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px; /* 125% */
  letter-spacing: 0.5px;
`;

const LightText = styled.div`
  color: #6f7171;
  font-feature-settings: "clig" off, "liga" off;
  /* [VDS] DeskTab/🖥 Body LG */
  font-family: "Verizon-NHG-eDS";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.5px;
`;
const SelectCompanion = ({
  onImageDownloadFailed,
  FOVDatas,
  associatedCompanionId,
  companionDevices,
  onDisableChange,
  editFlow,
}) => {
  const dispatch = useDispatch();
  const {
    camDetails,
    companionSelected,
    // snapshots,
    companionList,
    selectedCameraQR,
  } = useSelector((state) => state.cameraonboardingReducer);
  const { cameraList, fovList, companionDeviceList } = useSelector(
    (state) => state?.deviceReducer
  );
  const unpairedCameraReducerList = useSelector((state) => state.deviceReducer.discoveredCamerasList);
  const fieldOfViews =
    useSelector((state) => state.cameraonboardingReducer.fovNames) || [];
  const fovIdsForSelectedCameraQA = fieldOfViews?.map((item) => item.fovId);
  const isPairing = camDetails?.isPairing;
  const companionSelectedId = companionSelected.id;
  const [associatedCompList, setAssociatedCompList] = useState([]);
  const [isCCDLimitModalVisible, setIsCCDLimitModalVisible] = useState(false);
  const [selectedCompanionName, setSelectedCompanionName] = useState("");
  const [selectedCompanionFovStreamCount, setSelectedCompanionFovStreamCount] =
    useState(0);
  const [
    selectedCompanionFovStreamAvailabilityCount,
    setSelectedCompanionFovStreamAvabilityCount,
  ] = useState(0);
  // change companion - for unpaired camera
  const changeCompanion = (event) => {
    const companionName = event.target[event.target.selectedIndex].text;
    const companionValue = event.target.value;
    
    const fovsOfSelectedCompanionCamera = unpairedCameraReducerList?.find(
      (item) =>
        item?.discoveredby === companionValue &&
        item?.qrcode === selectedCameraQR
    )?.fovs;
    const FovNames =  fovsOfSelectedCompanionCamera?.map((item) => {
      return { fovName: item.fovName, fovId: item.fovID };
    });

    dispatch(getFovNames(FovNames));

    const companion = companionDeviceList?.find(
      (item) => item.id === companionValue
    );
    setSelectedCompanionName(companionName);

    checkCompanionStreamLimitCounts(companion);

    dispatch(
      setSelecedCompanion({
        id: companionValue,
        name: companionName,
        qrcode: companion?.qrcode,
      })
    );
    dispatch(setFloorSelected({ name: "", id: "", imageid: "", imageurl: "" }));
  };

  const checkCompanionStreamLimitCounts = (companion) => {
    if(isPairing){
    const cameraWithSelectedCompanion = cameraList.filter((camera) => {
      return camera?.parentdeviceid == companion?.id;
    });
    const cameraWithSelectedCompanionIdList = cameraWithSelectedCompanion.map(
      (m) => m?.id
    );

    const fovLsitWithCompanionId = fovList.filter((fov) => {
      return (
        cameraWithSelectedCompanionIdList.indexOf(fov?.parentdeviceid) > -1
      );
    });
    setSelectedCompanionFovStreamCount(fovLsitWithCompanionId.length);

    if (
      companion?.productmodel != undefined &&
      CCD_MODEL_SMALL.indexOf(companion?.productmodel?.replaceAll(" ", "")) > -1
    ) {
      if (fovLsitWithCompanionId.length >= CCD_MODEL_SMALL_LIMIT  || fovIdsForSelectedCameraQA.length > (CCD_MODEL_SMALL_LIMIT - fovLsitWithCompanionId.length) ) {
        onDisableChange(true);
        setIsCCDLimitModalVisible(true);
        setSelectedCompanionFovStreamAvabilityCount(
          CCD_MODEL_SMALL_LIMIT - fovLsitWithCompanionId.length > 0
            ? CCD_MODEL_SMALL_LIMIT - fovLsitWithCompanionId.length
            : 0
        );
        return;
      }
       else {
        setSelectedCompanionFovStreamAvabilityCount(
          CCD_MODEL_SMALL_LIMIT - fovLsitWithCompanionId.length
        );
      }
    } else if (
      companion?.productmodel != undefined &&
      CCD_MODEL_MEDIUM.indexOf(companion?.productmodel?.replaceAll(" ", "")) >
        -1
    ) {
      if (fovLsitWithCompanionId.length >= CCD_MODEL_MEDIUM_LIMIT  || fovIdsForSelectedCameraQA.length > (CCD_MODEL_MEDIUM_LIMIT - fovLsitWithCompanionId.length)) {
        onDisableChange(true);
        setIsCCDLimitModalVisible(true);
        setSelectedCompanionFovStreamAvabilityCount(
          CCD_MODEL_MEDIUM_LIMIT - fovLsitWithCompanionId.length > 0
            ? CCD_MODEL_MEDIUM_LIMIT - fovLsitWithCompanionId.length
            : 0
        );
        return;
      } else {
        setSelectedCompanionFovStreamAvabilityCount(
          CCD_MODEL_MEDIUM_LIMIT - fovLsitWithCompanionId.length
        );
      }
    } else {
      if (fovLsitWithCompanionId.length >= CCD_MODEL_SMALL_LIMIT || fovIdsForSelectedCameraQA.length > (CCD_MODEL_SMALL_LIMIT - fovLsitWithCompanionId.length) ) {
        onDisableChange(true);
        setIsCCDLimitModalVisible(true);
        setSelectedCompanionFovStreamAvabilityCount(
          CCD_MODEL_SMALL_LIMIT - fovLsitWithCompanionId.length > 0
            ? CCD_MODEL_SMALL_LIMIT - fovLsitWithCompanionId.length
            : 0
        );
        return;
      } else {
        setSelectedCompanionFovStreamAvabilityCount(
          CCD_MODEL_SMALL_LIMIT - fovLsitWithCompanionId.length
        );
      }
    }
  }
  };

  useEffect(() => {
    if (isPairing && companionDeviceList?.length && !companionSelectedId) {
      const { id, name, qrcode } = companionDeviceList[0];
      dispatch(
        setSelecedCompanion({
          id,
          name,
          qrcode,
        })
      );
      dispatch(
        setFloorSelected({ name: "", id: "", imageid: "", imageurl: "" })
      );
    }
  }, [isPairing, companionDeviceList, companionSelectedId]);

  useEffect(() => {
    if (companionList != undefined && companionList?.length > 0) {
      const d = companionList.find((c) => c.id == companionSelectedId);
      if (d != undefined) {
        checkCompanionStreamLimitCounts(
          companionDeviceList.find((e) => e.id == d.id)
        );
      }
    }
  }, [companionList]);

  const getCompanionObjectByRefId = (
    associatedCompanionId,
    companionDevices
  ) => {
    const filteredCompanionDevices = companionDevices?.filter(
      (item) => item.qrcode === associatedCompanionId.qrcode
    );
    return filteredCompanionDevices;
  };

  useEffect(() => {
    const compName = getCompanionObjectByRefId(
      associatedCompanionId,
      companionDevices
    );
    setAssociatedCompList([compName]);
  }, [associatedCompanionId]);

  return (
    <CompanionGrayContainer>
      <div style={{ display: "flex" }}>
        {fovIdsForSelectedCameraQA?.map((fovid) => {
          if(editFlow) {
            const SnapshotImg = snapshotImage(
              BasicSnapshot,
              fovid,
              selectedCameraQR,
              StreamType.PAIRED_CAMERA
            );
            return <SnapshotImg />;
          } else {
            const SnapshotImg = snapshotImage(
              BasicSnapshot,
              fovid,
              selectedCameraQR,
              StreamType.UNPAIRED_CAMERA,
              companionSelected?.id
            );
            return <SnapshotImg />;
          }
        })}
      </div>

      <Line type="secondary" />
      <FloorText>Select the companion device for this camera</FloorText>
      <DropdownSelect
        label="Companion device"
        readOnly={!camDetails?.isPairing}
        required={true}
        inlineLabel={false}
        onChange={changeCompanion}
        width="328px"
      >
        <option></option>
        {companionList &&
          companionList.map((item) => (
            <option
              selected={item?.id === companionSelected.id}
              key={item?.id}
              value={item?.id}
            >
              {item?.name}
            </option>
          ))}
      </DropdownSelect>
      {isPairing && <BIContent>
        <BoldText> Companion availability:</BoldText>
        <LightText>
          {selectedCompanionFovStreamAvailabilityCount + " camera streams."}
        </LightText>
      </BIContent>}

      {isPairing && <BIContent>
        <LightText> Companion use:</LightText>
        <LightText>
          {selectedCompanionFovStreamCount + " camera streams."}
        </LightText>
      </BIContent>}

      <SelectFloorPlan onImageDownloadFailed={onImageDownloadFailed} />

      <Modal
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        opened={isCCDLimitModalVisible}
        hideCloseButton={false}
        closeButton={
          <div
            style={{
              cursor: "pointer",
              position: "absolute",
              right: "25px",
              top: "25px",
            }}
            onClick={() => {
              //setLicenseSwitchMessage("");
              setIsCCDLimitModalVisible(false);
            }}
            data-testid={CAMERA_ONBOARDING_TEST_IDS.CCD_LIMIT_MODAL_CLOSE_ICON}
          >
            <Icon name="close" />
          </div>
        }
      >
        <ModalBody>
          <div style={{ overflow: "hidden" }}>
            <br />
            <Body
              size="medium"
              viewport="desktop"
              primitive="span"
              color="#000000"
            >
              <Notification
                type="error"
                title={`${selectedCompanionName ? selectedCompanionName : "This companion device"} is at capacity limit`}
                subtitle="No more cameras can be added to this device."
                disableFocus={false}
                hideCloseButton={true}
              />
            </Body>
            <div style={{ marginTop: "30px" }}>
              <ButtonGroup
                viewport={"desktop"}
                gap="16px"
                alignment="center"
                data={[
                  {
                    children: "Close",
                    size: "medium",
                    use: "primary",
                    width: "100%",
                    onClick: () => {
                      setIsCCDLimitModalVisible(false);
                    },
                    "data-testid": CAMERA_ONBOARDING_TEST_IDS.CCD_LIMIT_MODAL_CLOSE_BUTTON,
                  },
                ]}
              />
            </div>
          </div>
        </ModalBody>
      </Modal>
    </CompanionGrayContainer>
  );
};

export default SelectCompanion;
